export const ER_SUBJECT = 'language-arts';
export const ER_PASS_TOTAL = 4;
export const ER_WORD_TARGET_MIN = 300;
export const ER_WORD_TARGET_MAX = 500;

export function erQuizId(id) {
  return `er_${id}`;
}

export function countWords(text) {
  return String(text || '')
    .trim()
    .split(/\s+/)
    .filter(Boolean).length;
}

export function clampTrait(n) {
  const v = Math.round(Number(n));
  if (!Number.isFinite(v)) return 0;
  return Math.max(0, Math.min(2, v));
}

export function isErPassedByScores({ trait1, total } = {}) {
  return Number(total) >= ER_PASS_TOTAL && clampTrait(trait1) >= 1;
}

export function normalizeErScore(raw, wordCount) {
  const trait1 = clampTrait(raw?.trait1);
  const trait2 = clampTrait(raw?.trait2);
  const trait3 = clampTrait(raw?.trait3);
  const total = trait1 + trait2 + trait3;
  return {
    trait1,
    trait2,
    trait3,
    total,
    wordCount: Number(raw?.wordCount) || wordCount || 0,
    feedbackTrait1: String(raw?.feedbackTrait1 || '').trim(),
    feedbackTrait2: String(raw?.feedbackTrait2 || '').trim(),
    feedbackTrait3: String(raw?.feedbackTrait3 || '').trim(),
    passed: isErPassedByScores({ trait1, total }),
    displayPct: Math.round((total / 6) * 100),
  };
}

export function isRlaExtendedUnlocked(modules, daysByModule, completedLessons) {
  const rlaMods = (modules || []).filter((m) => m.subject === ER_SUBJECT);
  if (rlaMods.length === 0) return true;
  return rlaMods.every((mod) => {
    if (daysByModule[mod.id] === undefined) return false;
    const days = daysByModule[mod.id] || [];
    if (days.length === 0) return true;
    return days.every((d) => Boolean(completedLessons?.[d.id]));
  });
}

export function isErItemLocked(items, index, passedMap, clearedMap, rlaUnlocked) {
  if (!rlaUnlocked) return true;
  if (index <= 0) return false;
  const prev = items[index - 1];
  if (!prev) return false;
  return !(passedMap[prev.id] || clearedMap[prev.id]);
}

export function firstPendingExtendedResponse(items, passedMap, clearedMap) {
  return (items || []).find((item) => !(passedMap[item.id] || clearedMap[item.id])) || null;
}

export const GED_ER_TRAITS = [
  {
    id: 1,
    title: 'Trait 1 — Argument & Evidence',
    question: 'Did I prove my position using the passages?',
  },
  {
    id: 2,
    title: 'Trait 2 — Development & Organization',
    question: 'Did I explain my ideas clearly and logically?',
  },
  {
    id: 3,
    title: 'Trait 3 — English Conventions',
    question: 'Did I write clearly and correctly?',
  },
];

export const GED_ER_STRUCTURE = [
  'Introduction — issue, both positions, thesis (which is better supported)',
  'Strongest evidence — explain it and why it strengthens your claim',
  'Additional evidence — analyze and connect it to your thesis',
  'Opposing position — acknowledge it, then why its evidence is weaker',
  'Conclusion — restate your judgment and why that side is better supported',
];
